import { apiUrl } from '@/constants';
import axios from 'axios';

const state = {
  deliveries: [],
  delivery: null,
};

const mutations = {
  ADD_DELIVERY(state, delivery) {
    state.delivery = delivery;
  },
  SET_DELIVERIES(state, deliveries) {
    state.deliveries = deliveries
  }
};

const actions = {

  async addDelivery({ commit }, delivery) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${apiUrl}/deliveries`, delivery, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      commit('ADD_DELIVERY', response.data);

    } catch (error) {
      console.error('Error creating delivery:', error);
    }
  },
  async fetchDeliveries({ commit }) {
    try {
      const response = await axios.get(`${apiUrl}/deliveries`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },

      });
      commit('SET_DELIVERIES', response.data);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  },
  async deleteDelivery({ commit }, deliveryId) {
  try {
    const token = localStorage.getItem('token');
    await axios.delete(`${apiUrl}/deliveries/${deliveryId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    commit('SET_DELIVERIES', state.deliveries.filter(delivery => delivery.id !== deliveryId));
  } catch (error) {
    console.error('Error deleting delivery:', error);
  }
}
}


const getters = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
